import React from 'react';
import BaseSwiper from '@/components/swiper/BaseSwiper';
import { useClintMediaQuery } from '@/utils/hooks';

const MobileSwiper = (props: {
  chunkData: any[];
  chunkSize: number;
  slideClassName: string;
  swiperEle: (data: any) => React.ReactNode;
  tag?: string;
  bulletSx?: Record<string, any>;
  spaceBetween?: number;
}) => {
  const {
    chunkData,
    chunkSize,
    slideClassName,
    swiperEle,
    tag = 'div',
    bulletSx = {},
    spaceBetween = 16,
  } = props;
  const isMobile = useClintMediaQuery();
  if (!isMobile) {
    return null;
  }

  return (
    <BaseSwiper
      className="tablet:hidden"
      chunkData={chunkData}
      chunkSize={chunkSize}
      slideClassName={slideClassName}
      swiperEle={swiperEle}
      tag={tag}
      spaceBetween={spaceBetween}
      bulletSx={{
        '.swiper': { overflow: 'hidden' },
        '.swiper-pagination-bullet': {
          height: '6px',
          width: '6px',
          borderRadius: '3px',
          backgroundColor: '#bfdbfe',
          margin: '0 4px 0 0 !important',
          transition: 'background-color .5s ease,width .3s linear',
          '&s': { position: 'initial' },
          '&:not(&-active):hover': {
            backgroundColor: '#93c5fd !important',
          },
          '&-active': {
            width: '12px',
            backgroundColor: '#0050b3',
          },
        },
        ...bulletSx,
      }}
    />
  );
};

export default MobileSwiper;
